module.exports = __webpack_public_path__ + "static/img/基因组测序.31f25d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/二级标题Banner/基因组测序.jpg
// module id = 6JoE
// module chunks = 1